/* OddDrop tracking v3 — native Google owns the standard financial funnel. */
(function () {
  'use strict';
  if (window.OddTracking) return;
  var contextEl = document.getElementById('od-tracking-context');
  var cfg = {};
  try { cfg = JSON.parse(contextEl.textContent); } catch (_) { return; }
  var nativeEvents = cfg.native_events || [];
  var debug = new URLSearchParams(location.search).get('od_analytics_debug') === '1';
  var dryRun = new URLSearchParams(location.search).get('od_analytics_dryrun') === '1';
  var log = [], sequence = 0, cart = cfg.cart || { items: [], currency: cfg.currency };
  var onceKeys = {}, pendingList = [], listTimer, startedAt = Date.now();
  var labels = { ip_universe:'IP Universe', focus_headphones:"Today's Deal", featured:'Best Sellers', reviews:'Reviews', phone_cases_module:'Phone Cases', headphones_module:'Headphones & Earbuds', jjk_module:'JJK Exclusive', all:'You May Also Like', shorts:'See It In Action', history:'Recently Viewed', hero:'Brand Hero', faq:'FAQ' };
  var pageType = cfg.page_type === 'index' ? 'homepage' : cfg.page_type;
  var maxDepth = 0, maxScreen = 1, lastSection = '', visibleStart = document.hidden || !allowed() ? 0 : Date.now(), activeMs = 0, reportedMs = 0;
  var observers = [], lastAllowed = !!(window.OddConsent && window.OddConsent.allowed());
  function allowed() { return !!(window.OddConsent && window.OddConsent.allowed()); }

  function clean(value, limit) {
    var text = String(value == null ? '' : value).replace(/[\r\n\t]+/g, ' ').trim();
    if (/@/.test(text) || /\b\d{6,}\b/.test(text)) return '[redacted]';
    return text.slice(0, limit || 100);
  }
  function safePath(value) {
    try {
      var u = new URL(value, location.origin);
      var path = u.pathname.replace(/\/(tracking|orders|checkouts?|customers|account)(?:\/.*)?$/i, '/$1');
      path = path.replace(/\b\d{6,}\b/g, ':id').replace(/[^/\s]*@[^/\s]*/g, '[redacted]');
      return u.origin + path;
    } catch (_) { return ''; }
  }
  function common() {
    return {
      tracking_version: '20261028_links_v2', event_source: 'odddrop_theme',
      page_type: pageType, page_path: safePath(location.href).replace(location.origin,''),
      device_type: innerWidth <= 767 ? 'mobile' : (innerWidth <= 1024 ? 'tablet' : 'desktop')
    };
  }
  function attribution() {
    var out = {};
    if (window.OddAnalytics) {
      if (window.OddAnalytics.channel) Object.assign(out, window.OddAnalytics.channel());
      if (window.OddAnalytics.searchAttribution) Object.assign(out, window.OddAnalytics.searchAttribution());
    }
    return out;
  }
  function showDebug() {
    if (!debug || !document.body) return;
    var panel = document.getElementById('od-analytics-debug');
    if (!panel) {
      panel = document.createElement('details'); panel.id = 'od-analytics-debug'; panel.open = true;
      panel.style.cssText = 'position:fixed;bottom:8px;left:8px;z-index:2147483647;width:min(440px,94vw);max-height:36vh;overflow:auto;background:#10141b;color:#e7f3ff;border:1px solid #b5d6f5;border-radius:8px;padding:10px;font:12px/1.5 monospace;text-align:left';
      var title = document.createElement('summary'); title.textContent = 'OddDrop tracking QA'; panel.appendChild(title);
      var pre = document.createElement('pre'); pre.style.cssText = 'white-space:pre-wrap;margin:6px 0'; panel.appendChild(pre); document.body.appendChild(panel);
    }
    var counts = {};
    log.forEach(function (row) { counts[row.event] = (counts[row.event] || 0) + 1; });
    panel.querySelector('pre').textContent = JSON.stringify({ version:'20261028_links_v2', mode:dryRun ? 'dry_run' : 'debug_to_ga4', consent:window.OddConsent ? window.OddConsent.state() : {ready:false,analytics:false}, page_type:pageType, native_events:nativeEvents, emitted:log.length, event_counts:counts, events:log.slice(-4) }, null, 2);
    panel.setAttribute('data-event-count', String(log.length));
  }
  function emit(name, params) {
    // Never emit native financial events from bespoke hooks, including old queued hooks.
    if (nativeOwned(name)) return false;
    if (!dryRun && !allowed()) return false;
    params = Object.assign(common(), attribution(), params || {});
    // Result-set totals and qualified exits can contain both tiers; never inherit the last clicked product's tier.
    if (/^(search_final_results|search_predictive_results|search_engagement)$/.test(name)) delete params.search_match_type;
    if (params.search_term) params.search_term = clean(params.search_term, 60);
    if (params.normalized_term) params.normalized_term = clean(params.normalized_term, 60);
    if (params.value != null) {
      params.value = Math.round(Number(params.value || 0) * 100) / 100;
      params.currency = params.currency || cart.currency || cfg.currency;
    }
    if (params.items) {
      params.items = params.items.slice(0, 200);
      params.currency = params.currency || cart.currency || cfg.currency;
    }
    // Search attribution stays on search and commerce events, not unrelated page/content events.
    if (!/^(?:search|site_search|predictive_|cart_|view_cart|remove_from_cart|select_item|product_detail_view|checkout_click)/.test(name)) {
      ['search_term','normalized_term','search_source','search_result_count','search_position','search_session_id','search_item_id','search_match_type'].forEach(function (key) { delete params[key]; });
    }
    // Leave space for native GA fields. Identity/channel/item context takes precedence over debug dimensions.
    var optional = ['first_content','first_source','viewport_height','document_height','page_path'];
    while (Object.keys(params).filter(function (k) { return k !== 'transport_type'; }).length > 25 && optional.length) delete params[optional.shift()];
    var row;
    if (debug) {
      row = { n:++sequence, event:name, params:params, status:dryRun ? 'dry_run' : 'queued' };
      log.push(row); if (log.length > 120) log.shift(); showDebug();
    }
    if (dryRun) return true;
    if (!cfg.measurement_id || typeof window.gtag !== 'function') return;
    if (debug) {
      params.debug_mode = true;
      params.event_callback = function () { if (row) row.status = 'tag_callback'; showDebug(); };
      params.event_timeout = 2000;
    }
    params.send_to = cfg.measurement_id;
    params.transport_type = 'beacon';
    window.gtag('event', name, params);
    return true;
  }
  function once(key, name, params) {
    if (onceKeys[key] || (!dryRun && !allowed())) return;
    onceKeys[key] = true; emit(name, params);
  }
  function nativeOwned(name) { return nativeEvents.indexOf(name) !== -1; }
  function legacy(name, params) {
    if (name === 'shorts_play' || name === 'social_video_play') return emit('video_play_intent',Object.assign({video_module:name==='shorts_play'?'homepage':'product'},params));
    if (nativeOwned(name)) {
      if (name === 'search') {
        var searchKey = clean(params && params.search_term,60).toLowerCase();
        var previous = onceKeys.lastSearch;
        if (!previous || previous.term !== searchKey || Date.now() - previous.ts > 600) {
          onceKeys.lastSearch = {term:searchKey,ts:Date.now()}; emit('site_search', params);
        }
      }
      return;
    }
    // v2 measures real card impressions/selections centrally; video rails keep their own hooks.
    if (name === 'select_item' && !(params && params.items)) return;
    if (name === 'search_add_to_cart') return; // emitted only by the confirmed cart response below
    emit(name, params);
  }
  function productId(value) { return String(value || '').replace(/^gid:\/\/shopify\/(ProductVariant|Product)\//, ''); }
  function item(data, quantity) {
    var pid = productId(data.product_id || data.item_id || data.id);
    var vid = productId(data.variant_id || (data.product_id ? data.id : ''));
    return {
      item_id: vid ? 'shopify_' + (cfg.native_country || 'ZZ') + '_' + pid + '_' + vid : pid,
      product_id: pid, variant_id: vid, item_name:data.product_title || data.item_name || data.title || '',
      item_variant:data.variant_title || data.item_variant || '', item_category:data.product_type || data.item_category || '',
      item_brand:data.vendor || data.item_brand || '', price:Number(data.final_price != null ? data.final_price : data.price || 0) / 100,
      quantity:quantity == null ? Number(data.quantity || 1) : Number(quantity)
    };
  }
  function cartParams(value) {
    value = value || cart;
    return { currency:value.currency || cfg.currency, value:Number(value.total_price || 0) / 100, items:(value.items || []).map(function (it) { return item(it); }), item_count:Number(value.item_count || 0) };
  }
  function snapshotCart(strict) {
    return fetch('/cart.js', { credentials:'same-origin', cache:'no-store' }).then(function (r) { if (!r.ok) throw new Error('cart_snapshot'); return r.json(); }).then(function (data) { cart = data; return data; }).catch(function (error) { if(strict)throw error;return cart; });
  }
  function gaIdentity() {
    if (!allowed() || !cfg.measurement_id || typeof window.gtag !== 'function') return Promise.resolve(null);
    return new Promise(function(resolve){
      var client='',session='',finished=false;
      function finish(){if(finished)return;finished=true;resolve(/^\d+\.\d+$/.test(String(client))?{client_id:String(client),session_id:/^\d+$/.test(String(session))?String(session):''}:null);}
      window.gtag('get',cfg.measurement_id,'client_id',function(value){client=value;if(session)finish();});
      window.gtag('get',cfg.measurement_id,'session_id',function(value){session=value;if(client)finish();});
      setTimeout(finish,350);
    });
  }
  function cartView(source) {
    return snapshotCart(true).then(function () {
      emit(nativeOwned('view_cart') ? 'cart_drawer_open' : 'view_cart', Object.assign(cartParams(), { cart_surface:source }));
    }).catch(function () { commerceError('cart_view_snapshot','network'); });
  }
  function cartAdded(data, source) {
    var added = data.items || (data.id ? [data] : []);
    if (!added.length) return;
    var items = added.map(function (it) { return item(it); });
    var params = { currency:cart.currency || cfg.currency, value:items.reduce(function (sum,it) { return sum + it.price * it.quantity; }, 0), items:items, cart_surface:source || 'storefront' };
    emit('cart_add_success', params);
    if (!nativeOwned('add_to_cart')) emit('add_to_cart', params);
    var context = window.OddAnalytics && window.OddAnalytics.getSearchContext && window.OddAnalytics.getSearchContext();
    var ids = added.map(function (it) { return String(it.product_id); });
    if (context && ids.indexOf(String(context.search_item_id || '')) !== -1) emit('search_add_to_cart', params);
    return snapshotCart();
  }
  function cartChanged(before, after, line) {
    var previous = (before.items || [])[line - 1]; cart = after;
    if (!previous) return;
    var current = (after.items || []).find(function (it) { return it.key === previous.key; });
    var delta = Number(current && current.quantity || 0) - Number(previous.quantity || 0);
    if (!delta) return;
    var it = item(previous, Math.abs(delta));
    var params = { currency:after.currency || cfg.currency, value:it.price * Math.abs(delta), items:[it], quantity_change:delta };
    if (delta < 0 && !nativeOwned('remove_from_cart')) emit('remove_from_cart', params);
    if (delta > 0 && !nativeOwned('add_to_cart')) emit('add_to_cart', params);
    emit('cart_quantity_change', params);
  }
  function commerceError(action, status) { emit('cart_error', { cart_action:action, error_code:String(status || 'network') }); }

  function visible(el) { return !!(el && !el.closest('[hidden]') && el.getClientRects().length); }
  function sectionInfo(el) {
    var section = el.closest('.shopify-section') || el;
    var id = (section.id || '').replace(/^shopify-section-/, '').replace(/^template--\d+__/, '').slice(0,80);
    // Search has no visible heading; do not label valid results with a hidden empty-filter message.
    if (section.querySelector('[data-search-page]')) return {section_id:id || 'main',section_name:'Search results'};
    var title = section.querySelector('h1,h2,h3');
    return { section_id:id || 'content', section_name:labels[id] || clean(title && title.textContent || id || 'Content', 80) };
  }
  function listInfo(card) {
    var section = sectionInfo(card), list = section.section_id;
    if (card.closest('[data-zero-default-products], [data-zero-fandom-products], [data-zero-default], [data-zero-fandom], [data-filter-empty]')) list = 'search_fallback_recommendations';
    else if (card.closest('[data-model-support]')) list = 'model_support_recommendations';
    else if (card.closest('[data-anyip-promo]')) list = 'custom_display_recommendations';
    else if (card.closest('[data-more-series]')) list = 'same_series_recommendations';
    else if (card.closest('[data-od-history-grid]')) list = 'recently_viewed';
    else if (card.closest('[data-reco-mode="pdp"]')) list = 'pdp_recommendations';
    else if (card.closest('[data-od-reco-grid]')) list = 'home_recommendations';
    else if (card.closest('[data-search-page]')) list = 'search_results';
    else if (card.closest('[data-collection-grid]')) list = 'collection_' + (location.pathname.split('/').pop() || 'all');
    var container = card.closest('[data-search-grid], [data-collection-grid], [data-od-reco-grid], [data-od-history-grid], [data-model-support], [data-anyip-promo], [data-more-series-grid], [data-zero-default-products], [data-zero-fandom-products], [data-zero-default], [data-zero-fandom], .shopify-section');
    var cards = container ? Array.from(container.querySelectorAll('[data-product-card]')).filter(visible) : [card];
    return Object.assign(section, { item_list_id:list, item_list_name:section.section_name, index:Math.max(0,cards.indexOf(card)) });
  }
  function cardItem(card) {
    var btn = card.querySelector('[data-variant-id]');
    return item({ product_id:card.dataset.productId, variant_id:card.dataset.trackingVariantId || btn && btn.dataset.variantId,
      product_title:card.dataset.title, product_type:card.dataset.trackingProductType || card.dataset.kind,
      vendor:card.dataset.vendor, price:card.dataset.trackingPrice || card.dataset.price }, 1);
  }
  function flushList() {
    var groups = {};
    pendingList.splice(0).forEach(function (row) {
      var key = row.info.item_list_id;
      if (!groups[key]) groups[key] = { info:row.info, items:[] };
      groups[key].items.push(Object.assign(cardItem(row.card), row.info));
    });
    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      emit('view_item_list', { item_list_id:key, item_list_name:group.info.item_list_name, section_id:group.info.section_id, items:group.items });
    });
  }
  function observeContent() {
    if (!window.IntersectionObserver) return;
    observers.forEach(function (observer) { observer.disconnect(); }); observers = [];
    document.querySelectorAll('[data-od-tracking-observed]').forEach(function (el) { delete el.dataset.odTrackingObserved; });
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !visible(card) || (!dryRun && !allowed())) return;
        var info = listInfo(card), key = 'card:' + info.item_list_id + ':' + card.dataset.productId;
        if (onceKeys[key]) return;
        onceKeys[key] = true; pendingList.push({card:card,info:info});
        clearTimeout(listTimer); listTimer = setTimeout(flushList, 150);
      });
    }, { threshold:0.5 });
    observers.push(cardObserver);
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || !visible(entry.target)) return;
        var info = sectionInfo(entry.target); lastSection = info.section_id;
        var sections = Array.from(document.querySelectorAll('main .shopify-section'));
        once('section:' + info.section_id, 'section_view', Object.assign(info, {
          section_position:sections.indexOf(entry.target) + 1,
          screen_number:Math.floor((entry.target.getBoundingClientRect().top + scrollY) / Math.max(1,innerHeight)) + 1,
          viewport_height:innerHeight, document_height:document.documentElement.scrollHeight
        }));
        if (/focus|deal|promo/.test(info.section_id)) once('promotion:'+info.section_id,'view_promotion',{promotion_id:info.section_id,promotion_name:info.section_name,creative_slot:info.section_id});
      });
    }, { rootMargin:'0px 0px -25% 0px', threshold:0 });
    observers.push(sectionObserver);
    function scan() {
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        if (card.dataset.odTrackingObserved) return;
        card.dataset.odTrackingObserved = '1'; cardObserver.observe(card);
      });
      document.querySelectorAll('main .shopify-section').forEach(function (section) {
        if (section.dataset.odTrackingObserved) return;
        section.dataset.odTrackingObserved = '1'; sectionObserver.observe(section);
      });
    }
    scan();
    var scanTimer;
    var observer = new MutationObserver(function (changes) {
      if (!changes.some(function (change) { return change.addedNodes.length; })) return;
      clearTimeout(scanTimer); scanTimer = setTimeout(scan,100);
    });
    observer.observe(document.getElementById('MainContent') || document.body, { childList:true, subtree:true });
    observers.push(observer);
  }
  var scrollTick = false;
  function depth() {
    scrollTick = false;
    var max = Math.max(0,document.documentElement.scrollHeight - innerHeight);
    var percent = max > 0 ? Math.min(100,Math.floor(scrollY / max * 100)) : 0;
    maxDepth = Math.max(maxDepth,percent);
    maxScreen = Math.max(maxScreen,Math.floor((scrollY + innerHeight * 0.75) / Math.max(1,innerHeight)) + 1);
    [25,50,75,90].forEach(function (threshold) {
      if (percent >= threshold) once('depth:'+threshold,'scroll_depth',{percent_scrolled:threshold,scroll_depth:threshold+'%',viewport_height:innerHeight,document_height:document.documentElement.scrollHeight});
    });
    once('screen:'+maxScreen,'screen_reach',{screen_number:maxScreen,viewport_height:innerHeight,document_height:document.documentElement.scrollHeight});
  }
  function summary() {
    var current = activeMs + (visibleStart ? Date.now() - visibleStart : 0);
    var delta = current - reportedMs;
    if (delta < 1000) return;
    reportedMs = current;
    emit('page_engagement_summary',{active_time_ms:delta,page_active_time_ms:current,max_scroll_percent:maxDepth,max_screen_number:maxScreen,last_section_id:lastSection});
  }
  function formType(form) {
    if (form.matches('form[action*="/search"], [data-results-search-form]')) return '';
    if (form.matches('.od-track-form')) return 'order_tracking';
    var type = form.querySelector('[name="form_type"]');
    if (type && type.value === 'customer') return 'newsletter';
    if (type && type.value === 'contact') return 'contact';
    if (form.querySelector('input[type="email"]')) return 'contact';
    return '';
  }
  function headerNavigation(link) {
    var nav = link.closest('#shNav');
    if (!nav || !nav.closest('header')) return null;
    var href = link.getAttribute('href') || '', url;
    try { url = new URL(href,location.origin); } catch (_) { return null; }
    if (!/^https?:$/.test(url.protocol)) return null;
    var links = Array.from(nav.querySelectorAll('a[href]'));
    var label = clean(link.textContent || link.getAttribute('aria-label'),80);
    var target = safePath(href).replace(location.origin,'');
    // Never send arbitrary query strings. Keep only the known public Deals filter
    // and FAQ anchor, which otherwise collapse into All Products and Home.
    var sale = /\/collections\/all\/?$/.test(url.pathname) && url.searchParams.get('filter') === 'sale';
    if (sale) target += '?filter=sale';
    if (url.hash === '#faq') target += '#faq';
    var routes = { 'phone-cases':'phone_cases', headphones:'headphones', all:'all_products', 'best-sellers':'best_sellers', 'new-arrivals':'new_arrivals', qa:'qa' };
    var route = url.pathname.replace(/\/$/,'').split('/').pop();
    var key = sale ? 'deals' : (url.hash === '#faq' ? 'qa' : routes[route]);
    // The target stays available to distinguish any future merchant-defined links.
    key = key || label.toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_|_$/g,'') || 'custom_link';
    return { navigation_location:'header', navigation_item:key.slice(0,80),
      navigation_label:label, navigation_target:target.slice(0,100),
      navigation_position:links.indexOf(link) + 1,
      navigation_surface:innerWidth <= 768 ? 'mobile_menu' : 'desktop_menu',
      link_path:safePath(href).replace(location.origin,'') };
  }
  function linkHash(value) {
    var hash = 2166136261;
    for (var i=0;i<value.length;i++) { hash ^= value.charCodeAt(i); hash = Math.imul(hash,16777619); }
    return ('00000000'+(hash>>>0).toString(16)).slice(-8);
  }
  function linkNavigation(link) {
    // Customer/account/checkout documents and the merchant exclusion controls are
    // not public-content tracking surfaces. Never read form values or URL tokens.
    if (/\/(?:account|customers|orders|checkouts?)(?:\/|$)/i.test(location.pathname) ||
        link.closest('#od-browser-exclusion-panel,#od-analytics-debug')) return null;
    var raw = (link.getAttribute('href') || '').trim(), url;
    if (!raw || /^(?:javascript|data|blob|vbscript):/i.test(raw)) return null;
    try { url = new URL(raw,location.origin); } catch (_) { return null; }
    if (!/^(?:https?:|mailto:|tel:)$/.test(url.protocol)) return null;
    if (/^#od-analytics-(?:exclude|include)/.test(url.hash)) return null;
    var header = headerNavigation(link), card = link.closest('[data-product-card]');
    var contact = url.protocol === 'mailto:' ? 'email' : (url.protocol === 'tel:' ? 'phone' : '');
    var external = !contact && url.origin !== location.origin;
    var kind = contact ? 'contact' : (raw === '#' ? 'control' : (link.hasAttribute('download') ? 'download' :
      (external ? 'external' : (/\/(?:checkouts?)(?:\/|$)/i.test(url.pathname) ? 'checkout' :
      (url.hash && url.pathname === location.pathname ? 'anchor' : 'internal')))));
    var target = contact ? url.protocol : safePath(raw).replace(location.origin,'');
    if (!contact) {
      // Allow only public, finite navigation state; never include search terms,
      // variant/customer/order IDs, email, tracking numbers, tokens or UTMs.
      if (/\/collections\/all\/?$/.test(url.pathname) && url.searchParams.get('filter') === 'sale') target += '?filter=sale';
      var page = url.searchParams.get('page');
      if (/^\d{1,3}$/.test(page || '') && Number(page)>0) target += (target.indexOf('?')<0?'?':'&')+'page='+Number(page);
      var sort = url.searchParams.get('sort_by');
      if (/^(?:manual|best-selling|title-ascending|title-descending|price-ascending|price-descending|created-ascending|created-descending)$/.test(sort || '')) target += (target.indexOf('?')<0?'?':'&')+'sort_by='+sort;
      if (url.hash && /^#[a-z][a-z0-9_-]{0,60}$/i.test(url.hash) && document.getElementById(url.hash.slice(1))) target += clean(url.hash,62);
    }
    var scope, surface, place = link.closest('footer,[role="contentinfo"]') ? 'footer' : (link.closest('header,[role="banner"]') ? 'header' : 'content');
    if (link.closest('#OddPredictiveSearch')) { surface='predictive_search'; scope=link.closest('#OddPredictiveSearch'); }
    else if (header) surface=header.navigation_surface;
    else if (place === 'footer') {
      scope=link.closest('.footer-col,.footer-social') || link.closest('footer');
      var title=scope && scope.querySelector('h4');
      surface=link.closest('.footer-social')?'footer_social':('footer_'+(clean(title && title.textContent,40).toLowerCase().replace(/[^a-z0-9]+/g,'_') || 'other'));
    } else if (link.closest('#cartDrawer,[data-cart-drawer]')) { place='cart';surface='cart_drawer';scope=link.closest('#cartDrawer,[data-cart-drawer]'); }
    else if (link.closest('.pdp-description')) { surface='product_description';scope=link.closest('.pdp-description'); }
    else if (link.closest('.page-content')) {
      surface=/\/pages\/guides\/?$/.test(location.pathname)?'guide_index':(document.querySelector('.page-content .od-guide-updated')?'guide_article':'page_content');
      scope=link.closest('.page-content');
    } else if (link.closest('nav[aria-label="Breadcrumb"],.pdp-breadcrumb,.breadcrumb')) { surface='breadcrumb';scope=link.closest('nav[aria-label="Breadcrumb"],.pdp-breadcrumb,.breadcrumb'); }
    else if (card) { surface=link.querySelector('img')?'product_card_image':'product_card_title';scope=card; }
    else if (link.closest('.quick-select-modal,[data-quick-select-modal]')) surface='quick_select';
    else if (link.closest('.pagination,[aria-label="Pagination"]')) surface='pagination';
    else if (place === 'header') surface=link.closest('.sh-logo')?'header_logo':'header_action';
    else surface=pageType === 'homepage'?'homepage_module':(pageType === 'cart'?'cart_page':'page_content');
    scope=scope || link.closest('.shopify-section,main') || document;
    var links=Array.from(scope.querySelectorAll('a[href]')), position=links.indexOf(link)+1;
    if (card && place !== 'cart') position=listInfo(card).index+1;
    var label=contact ? (contact === 'email'?'Contact email':'Contact phone') :
      (link.closest('[class*="jdgm"]') ? 'Review link' : clean(link.getAttribute('aria-label') || link.textContent.trim() || (link.querySelector('img') || {}).alt || 'Unlabelled link',80));
    var params=Object.assign({ navigation_location:place, navigation_item:'link_'+linkHash(target),
      navigation_label:label, navigation_target:target.length>100?target.slice(0,91)+'~'+linkHash(target):target,
      navigation_position:Math.max(1,position),navigation_surface:surface,link_path:contact?url.protocol:safePath(raw).replace(location.origin,'') },header || {});
    params.link_type=kind;
    params.page_path=safePath(location.href).replace(location.origin,'').slice(0,100);
    return Object.assign(sectionInfo(link),params);
  }
  function interactions() {
    document.addEventListener('click',function (event) {
      if (event.button != null && event.button !== 0) return;
      var target = event.target.closest ? event.target : event.target.parentElement;
      if (!target) return;
      var link = target.closest('a[href]');
      var navigation = link && linkNavigation(link);
      if (navigation) emit('navigation_click',navigation);
      var card = target.closest('[data-product-card]');
      if (link && card && /\/products\//.test(link.getAttribute('href') || '')) {
        var info = listInfo(card), it = Object.assign(cardItem(card),info);
        var collectionInput = document.getElementById('CollectionSearch');
        if (collectionInput && card.closest('[data-collection-grid]') && clean(collectionInput.value,60) && window.OddAnalytics && allowed()) {
          window.OddAnalytics.track('search_result_click',{search_term:clean(collectionInput.value,60),search_source:'collection',search_match_type:card.getAttribute('data-model-match-type')||'standard',item_id:card.dataset.productId,item_name:card.dataset.title,position:info.index+1});
        }
        emit('select_item',{item_list_id:info.item_list_id,item_list_name:info.item_list_name,section_id:info.section_id,items:[it]});
        if (allowed()) try { sessionStorage.setItem('od_item_list_context',JSON.stringify({ts:Date.now(),product_id:card.dataset.productId,info:info})); } catch (_) {}
      }
      if (target.closest('[data-quick-select], [data-add-to-cart], [data-buy-now], [data-focus-buy], [data-addon-add]')) {
        var button = target.closest('button,a');
        if (button && !button.disabled) emit('cart_add_intent',{cart_surface:target.closest('[data-addon]')?'cart_addon':(card?'product_card':(target.closest('[data-od-focus]')?'homepage_focus':'pdp')),buy_now:!!target.closest('[data-buy-now],[data-focus-buy]')});
      }
      if (target.closest('a[href*="/checkout"], button[name="checkout"]')) emit('checkout_click',cartParams());
      if (target.closest('[data-share]')) emit('share_intent',{content_type:'product',item_id:currentProduct().id || '',method:'share_button'});
      var thumb = target.closest('[data-thumb], [data-zoom-thumb]');
      if (thumb) emit('product_media_select',{media_index:Number(thumb.dataset.index || 0),product_id:String(currentProduct().id || '')});
      if (target.closest('[data-main-img]')) emit('product_zoom_open',{product_id:String(currentProduct().id || '')});
      var review = target.closest('[class*="jdgm"] a,[class*="jdgm"] button');
      if (review) emit('review_interaction',{interaction_type:/write|review-form/.test(review.className)?'write_review':'review_control'});
      if (link && !card) {
        var href = link.getAttribute('href') || '', place = link.closest('footer,[id*="footer"]') ? 'footer' : (link.closest('header,[id*="header"]') ? 'header' : 'content');
        if (/^(mailto:|tel:)/.test(href)) emit('contact_click',{contact_method:href.indexOf('mailto:')===0?'email':'phone',navigation_location:place});
        else if (/^https?:/.test(href) && new URL(href,location.origin).origin !== location.origin) emit('outbound_click',{link_url:safePath(href),navigation_location:place});
      }
      if (link && /focus|deal|promo/.test(sectionInfo(link).section_id)) {
        var promo = sectionInfo(link);
        emit('select_promotion',{promotion_id:promo.section_id,promotion_name:promo.section_name,creative_slot:promo.section_id});
      }
      var filter = target.closest('[data-filter],.od-sort-opt');
      if (filter && !filter.closest('[data-search-page]')) setTimeout(function () {
        var root = filter.closest('.shopify-section') || document;
        var resultGrid = root.querySelector('[data-collection-grid], [data-search-grid]');
        emit('filter_results',{filter_type:filter.matches('.od-sort-opt')?'sort':'category',filter_value:clean(filter.getAttribute('data-filter') || filter.getAttribute('data-value'),60),result_count:Array.from((resultGrid || root).querySelectorAll('[data-product-card]')).filter(visible).length});
      },0);
    },true);
    // Middle-button new-tab activation uses auxclick rather than click.
    document.addEventListener('auxclick',function (event) {
      if (event.button !== 1) return;
      var target = event.target.closest ? event.target : event.target.parentElement;
      var link = target && target.closest('a[href]');
      var params = link && linkNavigation(link);
      if (params) emit('navigation_click',params);
    },true);
    document.addEventListener('toggle',function (event) {
      if (event.target.tagName === 'DETAILS' && event.target.open && event.target.id !== 'od-analytics-debug') {
        var title = event.target.querySelector('summary');
        if (event.target.matches('[data-order-note], [data-collection-intro]')) {
          emit('content_expand',{content_type:event.target.matches('[data-order-note]')?'order_note':'collection_intro',section_id:sectionInfo(event.target).section_id});
        } else emit('faq_open',{faq_title:clean(title && title.textContent,100),section_id:sectionInfo(event.target).section_id});
      }
    },true);
    document.addEventListener('focusin',function (event) {
      var form = event.target.closest('form'); if (!form) return;
      var type = formType(form); if (type) once('form-start:'+type,'form_interaction_start',{form_type:type});
    },true);
    document.addEventListener('submit',function (event) {
      var type = formType(event.target); if (type) emit('form_submit_intent',{form_type:type});
    },true);
    document.addEventListener('invalid',function (event) {
      var form = event.target.closest('form'); if (!form) return;
      var type = formType(form); if (type) emit('form_error',{form_type:type,error_type:'validation',field_type:event.target.type || 'unknown'});
    },true);
    document.addEventListener('change',function (event) {
      var select = event.target;
      if (select.matches('[data-option-select]')) emit('variant_option_select',{option_position:Number(select.dataset.optionPosition || 0),option_value:clean(select.value,100),product_id:String(currentProduct().id || '')});
      if (select.matches('[data-qty-input]')) emit('product_quantity_select',{quantity:Math.max(1,Number(select.value || 1)),product_id:String(currentProduct().id || '')});
      if (select.matches('[name="country_code"], [name="language_code"]')) emit('localization_change',{setting:select.name,selected_value:clean(select.value,20)});
    },true);
    document.querySelectorAll('form').forEach(function (form) {
      var type = formType(form); if (!type) return;
      if (form.querySelector('.form-success,.form__message--success,[data-form-status="success"]')) emit('form_success',{form_type:type});
      if (form.querySelector('.errors,[data-form-status="error"]')) emit('form_error',{form_type:type,error_type:'server_validation'});
    });
  }
  function currentProduct() {
    try { return JSON.parse((document.querySelector('[data-od-current-product]') || {}).textContent || '{}'); } catch (_) { return {}; }
  }
  function productDetail() {
    if(pageType !== 'product') return;
    var product=currentProduct(), context=null;
    if(allowed()) try {context=JSON.parse(sessionStorage.getItem('od_item_list_context') || 'null');} catch(_) {}
    if(!context || Date.now()-context.ts>30*60*1000 || String(context.product_id)!==String(product.id)) context=null;
    once('product-detail','product_detail_view',Object.assign({product_id:String(product.id || ''),product_name:product.title || ''},context?context.info:{}));
  }
  function collectionSearch() {
    var input = document.getElementById('CollectionSearch'); if (!input) return;
    var timer, last = '';
    function record(source) {
      var term = clean(input.value,60);
      if (!term) { last=''; if(window.OddAnalytics && window.OddAnalytics.clearSearchContext) window.OddAnalytics.clearSearchContext(); return; }
      if (term === last) return; last = term;
      var root = input.closest('.shopify-section') || document;
      var count = Array.from(root.querySelectorAll('[data-collection-grid] [data-product-card]')).filter(visible).length;
      var params={search_term:term,normalized_term:term,result_count:count,search_result_count:count,search_source:typeof source === 'string' ? source : 'collection',search_scope:'collection'};
      if(window.OddSearchIntent){Object.assign(params,OddSearchIntent.counts(Array.from(root.querySelectorAll('[data-collection-grid] [data-product-card]')).filter(visible)));OddSearchIntent.recordResults(root,term,'collection');}
      if(window.OddAnalytics) {
        window.OddAnalytics.track('search',params);
        window.OddAnalytics.track('search_results_view',params);
        if (!count) window.OddAnalytics.track('search_no_results',params);
      }
    }
    window.OddTracking.collectionSearchRecord = record;
    input.addEventListener('input',function () { clearTimeout(timer); timer = setTimeout(record,900); });
    input.addEventListener('change',function () { clearTimeout(timer); record(); });
  }
  function media() {
    document.addEventListener('play',function (event) {
      if (event.target.tagName !== 'VIDEO') return;
      emit('product_video_start',{video_provider:'html5',video_id:safePath(event.target.currentSrc).split('/').pop()});
    },true);
    document.addEventListener('ended',function (event) {
      if (event.target.tagName === 'VIDEO') emit('product_video_complete',{video_provider:'html5',video_id:safePath(event.target.currentSrc).split('/').pop()});
    },true);
    document.addEventListener('timeupdate',function (event) {
      var video = event.target;
      if (video.tagName !== 'VIDEO' || !isFinite(video.duration) || !video.duration) return;
      [25,50,75].forEach(function (p) {
        var key = 'video:'+safePath(video.currentSrc)+':'+p;
        if (video.currentTime / video.duration * 100 >= p) once(key,'product_video_progress',{video_provider:'html5',video_id:safePath(video.currentSrc).split('/').pop(),video_percent:p});
      });
    },true);
    window.addEventListener('message',function (event) {
      if (!/^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(event.origin)) return;
      var frame = Array.from(document.querySelectorAll('iframe')).find(function (f) { return f.contentWindow === event.source; });
      if (!frame) return;
      var data; try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (_) { return; }
      if (!data) return;
      var state = data.event === 'onStateChange' ? data.info : data.info && data.info.playerState;
      var url = new URL(frame.src,location.origin), id = url.pathname.split('/').pop();
      if (state === 1) once('yt:start:'+id,'product_video_start',{video_provider:'youtube',video_id:id});
      if (state === 0) once('yt:end:'+id,'product_video_complete',{video_provider:'youtube',video_id:id});
      var info = data.info;
      if (info && info.duration && info.currentTime != null) [25,50,75].forEach(function (p) {
        if (info.currentTime / info.duration * 100 >= p) once('yt:'+id+':'+p,'product_video_progress',{video_provider:'youtube',video_id:id,video_percent:p});
      });
    });
  }
  function performanceMetrics() {
    if (!window.PerformanceObserver) return;
    var metrics = {}, cls = 0, sessionCls = 0, sessionStart = 0, sessionLast = 0;
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (e) { metrics.LCP = e.startTime; }); }).observe({type:'largest-contentful-paint',buffered:true}); } catch (_) {}
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (e) {
      if (e.hadRecentInput) return;
      if (e.startTime - sessionLast > 1000 || e.startTime - sessionStart > 5000) { sessionCls = 0; sessionStart = e.startTime; }
      sessionLast = e.startTime; sessionCls += e.value; cls = Math.max(cls,sessionCls); metrics.CLS = cls;
    }); }).observe({type:'layout-shift',buffered:true}); } catch (_) {}
    // A long interaction diagnostic is not labelled INP; correct INP needs percentile grouping.
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (e) {
      if (e.interactionId) metrics.max_interaction_duration = Math.max(metrics.max_interaction_duration || 0,e.duration);
    }); }).observe({type:'event',buffered:true,durationThreshold:40}); } catch (_) {}
    function report() {
      Object.keys(metrics).forEach(function (name) { once('metric:'+name,'web_performance',{metric_name:name,metric_value:Math.round(metrics[name]*1000)/1000}); });
    }
    document.addEventListener('visibilitychange',function () { if (document.hidden) report(); });
    window.addEventListener('pagehide',report);
  }
  function init() {
    observeContent(); interactions(); collectionSearch(); media(); performanceMetrics(); depth(); showDebug();
    if (pageType === 'cart') cartView('cart_page');
    if (pageType === '404') emit('page_not_found',{});
    productDetail();
    window.addEventListener('scroll',function () { if (!scrollTick) { scrollTick = true; requestAnimationFrame(depth); } },{passive:true});
    window.addEventListener('resize',depth,{passive:true});
    window.addEventListener('pageshow',depth);
    document.addEventListener('visibilitychange',function () {
      if (document.hidden) { if (visibleStart) activeMs += Date.now()-visibleStart; visibleStart=0; summary(); }
      else visibleStart=allowed() ? Date.now() : 0;
    });
    window.addEventListener('pagehide',function () { flushList(); summary(); });
    window.addEventListener('error',function (event) {
      if (event.target && event.target !== window) {
        if (event.target.tagName === 'IMG') emit('resource_error',{resource_type:'image',resource_path:safePath(event.target.currentSrc || event.target.src).slice(0,100)});
      } else if (event.filename && new URL(event.filename,location.origin).origin === location.origin) emit('javascript_error',{error_type:'runtime',script_path:safePath(event.filename).replace(location.origin,''),line_number:Number(event.lineno || 0)});
    },true);
    window.addEventListener('unhandledrejection',function () { emit('javascript_error',{error_type:'unhandled_rejection'}); });
  }
  window.OddTracking = { emit:emit, legacy:legacy, nativeOwned:nativeOwned, snapshotCart:snapshotCart, cartAdded:cartAdded, cartChanged:cartChanged, cartView:cartView, cartParams:cartParams, commerceError:commerceError, clean:clean, gaIdentity:gaIdentity };
  document.addEventListener('od:consent',function (event) {
    var state=event.detail || {}, wasAllowed=lastAllowed;
    lastAllowed=state.analytics === true;
    if (state.analytics && !wasAllowed) {
      // Start with the currently visible page; never replay pre-consent actions.
      onceKeys={}; pendingList=[]; activeMs=0; reportedMs=0; maxDepth=0; maxScreen=1;
      visibleStart=document.hidden ? 0 : Date.now();
      observeContent(); depth(); productDetail();
    } else if(!state.analytics) {
      pendingList=[]; activeMs=0; reportedMs=0; visibleStart=0;
    }
    showDebug();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
